export const inputStyles = {
  borderBottom: `1px dashed #C0C0C0`,
  paddingBottom: 6,
  marginBottom: 6,
  fontSize: 17,
} as const;
